import { useEffect, useRef } from "preact/hooks";
import { strings } from "../i18n/strings.es-AR.js";

// Diálogo modal de confirmación para acciones que no se pueden deshacer
// (hoy: cerrar sesión, que borra el hilo del dispositivo).
// Se cierra con Escape, con el botón cancelar o tocando fuera de la tarjeta.
export function ConfirmDialog({ title, body, confirmLabel, cancelLabel, onConfirm, onCancel }) {
  const cancelRef = useRef(null);

  useEffect(() => {
    // El foco arranca en la opción segura: un Enter distraído no borra nada.
    cancelRef.current?.focus();
    const onKeyDown = (e) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onCancel]);

  return (
    <div
      class="fixed inset-0 z-30 flex items-center justify-center bg-black/50 px-6"
      onClick={onCancel}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        class="w-full max-w-sm rounded-2xl bg-white p-5 shadow-xl dark:bg-slate-900"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 class="text-base font-semibold text-slate-900 dark:text-white">{title}</h2>
        <p class="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-300">{body}</p>
        <div class="mt-5 flex justify-end gap-2">
          <button
            ref={cancelRef}
            type="button"
            class="rounded-full px-4 py-2 text-sm font-medium text-slate-600 active:bg-slate-100 dark:text-slate-300 dark:active:bg-slate-800"
            onClick={onCancel}
          >
            {cancelLabel || strings.cancel}
          </button>
          <button
            type="button"
            class="rounded-full bg-flux-primary px-4 py-2 text-sm font-medium text-white active:bg-flux-primary-dark"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
